import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { IPcrs } from '../../pcr/store/pcr.types'
import { setErrorMessage, showToast } from '../../../components/apiErrorHandler/store/apiErrorHandler.actions'
import { IUserState } from '../../user/store/user.types'
import { getUserSelector } from '../../user/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { HomeConstants } from '../store/home.constants'
import { IPcrSummaries } from '../store/home.types'

export function* checkForFailedAutoUploads() {
  const user: IUserState = yield select(getUserSelector)
  const { serviceId, userId } = user
  const pcrDocsService = new PcrDocsService(serviceId)
  try {
    const pcrDocs: IPcrSummaries = yield call([pcrDocsService, pcrDocsService.getPCRDocsPerUser], userId)
    // notify user for failed charts
    if (pcrDocs?.length === 0) return
    const failedCharts = pcrDocs.filter((pcr) => !!pcr.lastAutoUploadDateTime)

    if (failedCharts && failedCharts.length > 0) {
      yield put(
        setErrorMessage('Previously created charts remain on this device.  Please review and upload these charts.')
      )
      yield put(showToast(true))
      const fullPcrDocs: IPcrs = yield all(
        failedCharts.map((summary) => call([pcrDocsService, pcrDocsService.getPCR], summary.pcrId))
      )

      // yield all to update failed charts in parallel
      const fullPcrDocsUpdated = fullPcrDocs.map((pcr) =>
        call([pcrDocsService, pcrDocsService.savePCR], {
          ...pcr,
          submitChart: { ...pcr.submitChart, lastAutoUploadDateTime: null },
        })
      )

      yield all(fullPcrDocsUpdated)
    }
  } catch (e) {
    yield put(throwPcrException(`checkForFailedAutoUploads() error: ${e}`))
  }
}

export function* checkForFailedAutoUploadsSaga() {
  yield takeLatest([HomeConstants.CHECK_FOR_FAILED_AUTO_UPLOADS], checkForFailedAutoUploads)
}
